<template>
    <div>
        <span
            v-if="row.confirmed"
            title="Yes"
            >Yes</span
        >
        <span
            v-else
            title="No"
        >
            No
            <div
                class="invite"
                :class="{ 'invite--success': inviteSent }"
            >
                <a
                    class="invite__link"
                    href="#"
                    title="Reinvite"
                    @click.prevent="resend($event)"
                    >Reinvite</a
                >

                <div class="invite__message">Sent!</div>
            </div>
        </span>
    </div>
</template>

<script>
import canToast from '@/mixins/canToast'
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'

export default {
    mixins: [canToast, needsOrganizationSlug],
    props: ['row'],

    data() {
        return {
            inviteSent: false,
        }
    },
    methods: {
        resend(e) {
            if (this.inviteSent) {
                return
            }

            const user = this.row
            this.$http.post(`${this.organizationSlug}/users/reinvite`, { users: [user.id] }).then(({ data }) => {
                this.toast('User successfully re-invited!')
                this.inviteSent = true
            })
        },
    },
}
</script>

<style scoped lang="scss">
@use '@sass/_variables.scss' as *;

.invite {
    position: relative;
    margin-top: 15px;
    height: 20px;

    .invite__link {
        position: absolute;
        z-index: 1;
        opacity: 1;
    }
    .invite__message {
        opacity: 0;
        position: absolute;
        z-index: 0;
    }
    &--success {
        .invite__message {
            opacity: 1;
            -webkit-transition: opacity 0.5s;
            transition: opacity 0.5s;
            color: $green;
        }
        .invite__link {
            opacity: 0;
            -webkit-transition: opacity 0.5s;
            transition: opacity 0.5s;
            cursor: default;
        }
    }
}
</style>
